/**
 * Defines a collection view of buttons specific to reporting actions
 */

import ButtonCollectionView from "../../../views/generic/button/collection";
import ButtonView from "../../../views/generic/button";

const DEFAULTS = {
  childView: ButtonView,
};

class View extends ButtonCollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  className() {
    return "btn-group pull-right";
  }
}

export { View as default };
